import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import PageHeader from '../page-header/page-header.jsx';
import Card from '../card/card.jsx';

function MigrationPlaceholderPage() {
  const location = useLocation();

  return (
    <div>
      <PageHeader
        title="Page is not migrated yet"
        subtitle="This route already exists in V2 and is ready for domain migration."
      />

      <Card title="Current Route">
        <p className="mb-2">{location.pathname}</p>
        <p className="mb-0">
          Open main dashboard: <Link to="/dashboard">go to dashboard</Link>
        </p>
      </Card>
    </div>
  );
}

export default MigrationPlaceholderPage;
